/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.services {

    declare var _LTracker: any;

    export class WarsLogger {

        // 1-DEBUG, 2-INFO, 3-WARN, 4-ERROR, 5-FATAL, 6-OFF
        private static logLevel: number = 3;

        private static logToConsole: boolean = true;
        // E.g. console.error
        private static useConsoleLevels: boolean = true;

        private static logToLoggly: boolean = true;

        public static logDebug(message: string, source: string, logContext?: any): void {
            if (this.logLevel > 1) return;
            WarsLogger.log(message, source, 'DEBUG', logContext);
        }

        public static logInfo(message: string, source: string, logContext?: any): void {
            if (this.logLevel > 2) return;
            WarsLogger.log(message, source, 'INFO', logContext);
        }

        public static logWarn(message: string, source: string, logContext?: any): void {
            if (this.logLevel > 3) return;
            WarsLogger.log(message, source, 'WARN', logContext);
        }

        public static logError(message: string, source: string, logContext?: any): void {
            if (this.logLevel > 4) return;
            WarsLogger.log(message, source, 'ERROR', logContext);
        }

        public static logFatal(message: string, source: string, logContext?: any): void {
            if (this.logLevel > 5) return;
            WarsLogger.log(message, source, 'FATAL', logContext);
        }

        private static log(message: string, source: string, level: string, logContext?: any): void {
            try {
                if (this.logToLoggly) {
                    const logObject: any = {
                        'message': message,
                        'level': level,
                        'source': source
                    };

                    if (logContext !== undefined) {
                        logObject.logContext = logContext;
                    }

                    _LTracker.push(logObject);
                }

                if (this.logToConsole) {
                    if (this.useConsoleLevels) {
                        if (level === "FATAL") {
                            console.error("Fatal !! - " + source + " - " + message);
                            if (logContext !== undefined) {
                                console.error(logContext);
                            }
                        } else if (level === "ERROR") {
                            console.error(source + " - " + message);
                            if (logContext !== undefined) {
                                console.error(logContext);
                            }
                        } else if (level === "WARN") {
                            console.warn(source + " - " + message);
                            if (logContext !== undefined) {
                                console.warn(logContext);
                            }
                        } else if (level === "INFO") {
                            console.info(source + " - " + message);
                            if (logContext !== undefined) {
                                console.info(logContext);
                            }
                        } else if (level === "DEBUG") {
                            console.debug(source + " - " + message);
                            if (logContext !== undefined) {
                                console.debug(logContext);
                            }
                        }
                    } else {
                        console.log(level + " - " + source + " - " + message);
                        if (logContext !== undefined) {
                            console.log(logContext);
                        }
                    }
                }
            } catch (err) {
                
            }
        }
    }
}

warsApp.registerService('WarsLogger', []);